controllers.controller('LoginSmsController', [
    '$scope', '$ionicHistory', '$ionicHistory', '$state', '$ionicLoading', 'constants', 'ErrorService', 'LoginService', 'LocaleService',
    'Validator', 'AccountService', '$injector', 'Utils', 'API',
    function ($scope, $ionicHistory, $ionicHistory, $state, $ionicLoading, Const, ErrorService, LoginService, LocaleService,
              Validator, AccountService, $injector, Utils, API) {

        $ionicHistory.nextViewOptions({
            disableAnimate: true
        });

        $scope.otpSent = false;

        LocaleService.wait().then(function (translation) {
            $scope.translation = translation;
        });

        $scope.navigate = function (state) {
            $state.go(state);
        };

        $scope.loginForm = {
            email: '',
            tokenThirdParty: '',
            provider: 'pandaotp',
            password: '',
            fingerprint: 123
        };

        $scope.modal = {
            actionText: LocaleService.translation.try_again,
            state: false
        };
 
        $scope.signUpURL = Utils.createLinkByLang('externalLinks.signUp', LocaleService.lang, 'externalLinks.signUpDefault');

        $scope.validator = Validator.getPattern;
        $scope.disableSignUp = Const['disableSignup'];

        $scope.sendOtp = function (form) {
            if (!form.$valid) return;

            $ionicLoading.show();

            var request = {
                email: $scope.loginForm.email,
                fingerprint: 123
            }

            API.sendOTP(request).then(function (res){

                if (res.status !== 1) {
                    throw new ErrorService({
                        source: 'LoginSmsController',
                        type: Const.error.type.VALIDATION,
                        code: res.code,
                        severity: 'warning',
                        data: {response: res}
                    });
                } else {
                    $scope.otpSent = true;
                    $ionicLoading.hide();
                }

            }).catch(function (error){
                $ionicLoading.hide();
                $scope.modal.isError = true;
                $scope.modal.textTitle = (error && LocaleService.translation.messages[error.code]) || LocaleService.translation.messages.Err600;
                $scope.modal.state = true;
            })
        };

        $scope.login = function (form){

            if (!form.$valid) return;

            $ionicLoading.show();

            LoginService.loginThirdParty($scope.loginForm.email, $scope.loginForm.provider, $scope.loginForm.tokenThirdParty)
                .then(function () {
                    $scope.loadingMessage = LocaleService.translation.starting;
                })
                .then(LoginService.initServices)
                .then(function () {
                    $ionicLoading.hide();

                    $injector.get('Init').isInitialized = true;
                    $ionicLoading.hide();

                    var state = AccountService.checkTradingAccounts();
                    if (state) return $state.go(state);

                    $state.go('root.app.assets');
                })
                .catch(function (error) {

                    // if (error === Const.loginStatus.failedActiveAccount) {
                    if (error && error.code === "authFailed") {
                        $ionicLoading.hide();
                        //popup
                        $scope.modal.isError = true;
                        $scope.modal.textTitle = LocaleService.translation.messages.mt4AuthFailed;
                        $scope.modal.back = 'login';
                        $scope.modal.state = true;
                        return;
                    }

                    //if we failed in starting any service - do logout sequence
                    LoginService.logout()
                        .then(function () {
                            $ionicLoading.hide();
                            $scope.modal.isError = true;
                            $scope.modal.textTitle = (error && LocaleService.translation.messages[error.code]) || LocaleService.translation.messages.Err600;
                            $scope.modal.state = true;
                        })
                        .catch(function (error) {
                            $ionicLoading.hide();
                            $scope.modal.isError = true;
                            $scope.modal.textTitle = (error && LocaleService.translation.messages[error.code]) || LocaleService.translation.messages.Err600;
                            $scope.modal.state = true;
                        })
                })
        }


    }]);
